import { useMutation, useQuery, useInfiniteQuery } from '@tanstack/react-query';
import axiosInstance from './axios';
import { CategoryGetAllResponseT } from '../types/categoryTypes';
import { PostDataT } from '../types/commonTypes';
import { GetSubCategoryInProductRequestT } from '../types/productTypes';

export const useAddCategory = () => {
  return useMutation({
    mutationKey: ['useAddCategory'],
    mutationFn: async (postData: {
      imageUrl: string;
      categoryName: string;
      description: string;
    }) => {
      const { data } = await axiosInstance.post('/category', postData);
      return data;
    },
  });
};

export const useUpdateCategory = () => {
  return useMutation({
    mutationKey: ['useUpdateCategory'],
    mutationFn: async (postData: {
      imageUrl: string;
      categoryName: string;
      description: string;
      id: string;
    }) => {
      const { data } = await axiosInstance.put('/category/update', postData);
      return data;
    },
  });
};

// export const useGetACategory = () => {
//   return useMutation<any, Error, string>({
//     mutationKey: ['useGetACategory'],
//     mutationFn: async (categoryId: string, subCategory = false) => {
//       try {
//         const { data } = await axiosInstance.get<any>(
//           `category/${categoryId}/${subCategory}`
//         );
//         return data;
//       } catch (error) {
//         throw new Error(
//           error.response?.data?.message || 'Failed to fetch product'
//         );
//       }
//     },
//   });
// };

export const useGetACategory = ({
  categoryId,
  subCategory = false,
}: GetSubCategoryInProductRequestT) => {
  return useQuery({
    queryKey: ['useGetACategory', categoryId],
    queryFn: async () => {
      const { data } = await axiosInstance.get(
        `category/${categoryId}/${subCategory}`
      );
      return data as any;
    },
    enabled: !!categoryId,
  });
};

export const useDelCategory = () => {
  return useMutation({
    mutationKey: ['useDelCategory'],
    mutationFn: async (categoryId: string | undefined) => {
      const { data } = await axiosInstance.delete(`/category/${categoryId}`);
      return data;
    },
  });
};

export const useGetAllCategory = (postData: {
  pageNo: number;
  pageSize: number;
  isSubCategory: boolean;
  // enableFlag?: boolean;
}) => {
  return useQuery({
    queryKey: ['useGetAllCategory', postData],
    queryFn: async () => {
      const { data } = await axiosInstance.post(`/category/all`, postData);
      return data as CategoryGetAllResponseT;
    },
    // enabled: postData.enableFlag,
  });
};

export const useInfiniteGetAllCategory = (postData: PostDataT) => {
  return useInfiniteQuery({
    queryKey: [`useGetAllCategory`, postData],
    queryFn: async () => {
      const { data } = await axiosInstance.post(`/category/all`, {
        ...postData,
      });
      return data as CategoryGetAllResponseT & { hasNextPage?: boolean };
    },
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = lastPage.hasNextPage ? allPages.length + 1 : undefined;
      return nextPage;
    },
    initialPageParam: 1,
  });
};
